module.exports = __webpack_public_path__ + "03_glasses_red.913f338d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/03_glasses_red.png
// module id = 26pW
// module chunks = 0